<template>
  <div>
    <b-modal
      id="faqModal"
      title="Frequently Asked Questions"
      class="modal-lg"
      :ok-only="true"
      ok-title="Close"
      size="lg"
    >
      <div class="card card-faq" v-for="faq in Faqs" :key="faq.id">
        <h4 class="card-header" role="tab">
          <a v-b-toggle="'collapse' + faq.id" role="button">
            <font-awesome-icon icon="plus" class="fa fa-fw" />
            {{ faq.question }}
          </a>
        </h4>
        <b-collapse :id="'collapse' + faq.id">
          <div class="card-body">
            <ul class="list-unstyled list-expanded">
              <li v-for="(item, index) in faq.answerItems" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </b-collapse>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
library.add(faPlus);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    FontAwesomeIcon
  },
  name: "FaqList",
  props: ["faq"],
  computed: {
    Faqs() {
      if (!this.faq) {
        return new Array();
      }
      let faqs = [];
      this.faq.forEach((item, index) => {
        let faqItem = {
          id: index,
          question: item.title
        };
        let answerItems = [];
        item.paragraphs.forEach(paragraph => {
          answerItems.push(paragraph);
        });
        faqItem.answerItems = answerItems;
        faqs.push(faqItem);
      });
      return faqs;
    }
  }
};
</script>
